import React, { Component } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Item
} from "@dndModels";
import { 
  ITEM_TYPES 
} from "@dndModels/Constants";

import API from "@dndUtilities/system_api";

import StringBox from "@components/input/strings/StringBox";
import SelectBox from "@components/input/selects/SelectBox";
import SelectStringBox from "@components/input/selects/SelectStringBox"; 
import LoadingBox from "@components/input/LoadingBox";

type Props = {
  name: string;
  value: string;
  item_type: string;
  multiple: boolean;
  simple_view: boolean;
  values: string[];
  base_items: Item[] | null;
  onChange: Function;
  disabled: boolean;
}

export interface State {
  base_items: Item[];
  search_string: string;
  item_type: string;
  loading: boolean;
}

const api = API.getInstance();

class SelectBaseItemBox extends Component<Props, State> {
  public static defaultProps = {
    base_items: null,
    value: "",
    values: [],
    multiple: false,
    simple_view: false,
    item_type: "ALL",
    disabled: false
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      base_items: [],
      search_string: "",
      item_type: "ALL",
      loading: true
    };
  }

  componentDidMount() {
    this.load();
  }

  load() {
    this.setState({ loading: true }, () => {
      api.getObjects({data_type: "item"}).then(res => {
        const base_items = res as Item[];
        let search_string = this.state.search_string;
        let item_type = this.props.item_type;
        if (this.props.value !== "") {
          const objFinder = base_items.filter(o => o._id === this.props.value);
          if (objFinder.length === 1) {
            const obj = objFinder[0];
            search_string = obj.name;
            item_type = obj.item_type;
          }
        }
        this.setState({ 
          search_string,
          item_type,
          base_items, 
          loading: false 
        });
      });
    });
  }

  render() {
    if (this.state.loading) {
      return (<LoadingBox />);
    } else {
      let filtered: Item[] = this.props.base_items ? this.props.base_items : (this.state.base_items ? this.state.base_items : []);
      filtered = filtered.filter(o => 
        (this.state.item_type === "ALL" || this.state.item_type === o.item_type) &&
        (this.state.search_string === "" || o.name.toLowerCase().includes(this.state.search_string.toLowerCase()) || o.description.toLowerCase().includes(this.state.search_string.toLowerCase()))).sort((a,b) => {return a.name.localeCompare(b.name)});
      return (
        <Grid container spacing={0} direction="row">
          { !this.props.simple_view &&
            <Grid
              size={{
                xs: this.props.item_type === "ALL" ? 3 : 6
              }}>
              <StringBox
                name="Search"
                value={`${this.state.search_string}`}
                disabled={this.props.disabled}
                onBlur={(search_string: string) => {
                  this.setState({ search_string });
                }}
              />
            </Grid>
          }
          { !this.props.simple_view && this.props.item_type === "ALL" &&
            <Grid
              size={{
                xs: 3
              }}>
              <SelectStringBox
                name="Item Type"
                options={["ALL",...ITEM_TYPES]}
                value={this.state.item_type}
                disabled={this.props.disabled}
                onChange={(item_type: string) => {
                  this.setState({ item_type });
                }}
              />
            </Grid>
          }
          <Grid
            size={{
              xs: this.props.simple_view ? 12 : 6
            }}>
            { !this.props.simple_view && filtered.length > 20 ?
              <span>Too many base items { filtered.length }</span>
            : this.props.multiple ?
              <SelectBox 
                options={filtered}
                multiple
                values={this.props.values} 
                name={this.props.name}
                disabled={this.props.disabled}
                onChange={(ids: string[]) => {
                  this.props.onChange(ids);
                }}
              />
            :
              <SelectBox 
                options={filtered}
                value={this.props.value} 
                name={this.props.name}
                disabled={this.props.disabled}
                onChange={(id: string) => {
                  const objFinder = this.state.base_items ? this.state.base_items.filter(o => o._id === id) : [];
                  if (objFinder.length === 1) {
                    this.props.onChange(objFinder[0]._id);
                  }
                }}
              />
            }
          </Grid>
        </Grid>
      );
    }
  }
}

export default SelectBaseItemBox;
